(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pr_description"]) return;
  try {
    
function layoutVastraDescription() {
  document.querySelectorAll('.vc-description').forEach(function(description) {
    if (description.classList.contains('vc-has-specs')) return;
    var table = description.querySelector('table');
    if (!table) return;
    var copy = document.createElement('div');
    copy.className = 'vc-description-copy';
    while (description.firstChild) copy.appendChild(description.firstChild);
    var specs = document.createElement('div');
    specs.className = 'vc-description-specs';
    specs.appendChild(table);
    description.appendChild(copy);
    description.appendChild(specs);
    description.classList.add('vc-has-specs');
  });
}
layoutVastraDescription();
document.addEventListener('DOMContentLoaded', layoutVastraDescription);
document.addEventListener('shopify:section:load', layoutVastraDescription);

  } catch(e) { console.error(e); }
})();
})();
